import ApiService from "@/services/api.service";
import SettingsService from "@/services/settings.service.js";
/* eslint-disable */

const actions = {
  async getPlanPortalConfiguration({ commit }, options) {
    var settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/cms-content`;
    return ApiService.get(url);
  },
  async savePlanPortalConfiguration({ commit }, options) {
    var settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/cms-content`;
    return ApiService.post(url, options.payload);
  },
};
const mutations = {};
export const portalsProxy = {
  namespaced: true,
  actions,
  mutations,
};
